import { Paper, Box, Typography } from "@mui/material";
import { palette, theme  as colorTheme } from "../../../../Convoze.theme";


const colors = {
  // surface: "#0f1014",
  surface : colorTheme('palette', 'night').value,
  // border: "#1f1f23",
  border : colorTheme('palette', 'night').value,
  text: "#e5e7eb",
  // subtext: "#9aa0a6",
  subtext:colorTheme('palette', 'secondary').value,
  // accent: "#a78bfa",
  accent:colorTheme('palette', 'primary').value
};

export default function SummaryStat({ icon, label, value,color }) {
  return (
    <Paper
      elevation={0}
      sx={{
        border: `0.5px solid #E9E9EB`,
        borderRadius: 1,
        p: { xs: 1.75, sm: 1.2 },
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        // boxShadow: "0 4px 12px rgba(99, 102, 241, 0.3)", 
      }}
    >
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: 0.5,
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            fontSize:"1.125rem"
          }}
        >
          {icon}

          <Typography
            variant="h4"
            sx={{
              fontWeight: 700,
              fontSize: "1.125rem",
              color:color,
            }}
          >
            {value}
          </Typography>
        </Box>
        <Typography
          variant="subtitle2"
          sx={{ fontWeight: 600, fontSize:'0.71rem',color:colorTheme('palette', 'secondary').value}}
        >
          {label}
        </Typography>
      </Box>
    </Paper>
  );
}
